// extracted by mini-css-extract-plugin
export default {"meals":"availableMeals_meals__XZl1A","meals-appear":"availableMeals_meals-appear__YssZi","button":"availableMeals_button__KFyNP"};